
<div>

  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.formLinkable)">
    <panel-item id="pn-linked-form">
      <label :for="selectedObjectModelTrigger.idForProp('linked_form_id')" class="a-select-label">Generate Which
        Form?</label>
      <a-select
        v-model="linkedForm"
        bind-by-object
        :options="linkedFormVSelectOptions"
        compress
        :id="selectedObjectModelTrigger.idForProp('linked_form_id')"
        placeholder="Search forms..."></a-select>
    </panel-item>
  </panel-block>
  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.runMappable)">
    <panel-item id="ot-linked-mapping">
      <label :for="selectedObjectModelTrigger.idForProp('mapping_id')" class="a-select-label">
        Run which mapping?</label>
      <a-select :options="orgMappingsOptions"
                :id="selectedObjectModelTrigger.idForProp('mapping_id')"
                :key="selectedObjectModelTrigger.mapping_id ? selectedObjectModelTrigger.mapping_id: 'select-mapping'"
                bind-by-object
                compress
                v-model="linkedMapping"></a-select>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.runProcessable)">
    <panel-item id="ot-linked-process">
      <label :for="selectedObjectModelTrigger.idForProp('process_flow_id')" class="a-select-label">
        Run which process flow?</label>
      <a-select :options="orgProcessFlowOptions"
                :id="selectedObjectModelTrigger.idForProp('process_flow_id')"
                :key="selectedObjectModelTrigger.process_flow_id ? selectedProcessFlow.id: 'select-process-flow'"
                bind-by-object
                compress
                v-model="selectedProcessFlow"></a-select>
      <button v-if="selectedObjectModelTrigger.process_flow_id"
              id="configure-process-flow"
              class="btn grey-to-blue full-sz"
              @click="showProcessModal">
        Configure
      </button>
      <view-configure-process-flow-modal
        @toggle-modal="hideModal(vueModalID.configureObjectModelProcessFlow)"
        v-if="modalStateFor(vueModalID.configureObjectModelProcessFlow).isVisible"
        :state="modalStateFor(vueModalID.configureObjectModelProcessFlow)"
        :index="vueModalID.configureObjectModelProcessFlow"
        :parentModel="selectedObjectModelTrigger"
        :object-model="selectedObjectModel"
        :process-flow="selectedProcessFlow">
      </view-configure-process-flow-modal>
    </panel-item>
  </panel-block>

  <template v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.propertyUpdateable)">
    <template
      v-for="(propertyUpdate,  index) in selectedObjectModelTrigger.propertyUpdatesArray"
    >
      <panel-block :key="`update_value_${propertyUpdate.property_client_id}`">
        <configure-property-update
          :deleteable="index !== 0"
          :key="propertyUpdate.property_client_id"
          :property-update="propertyUpdate"
          :property-options="updateableProperties"
          v-on:remove="removePropertyUpdate(propertyUpdate)"
        >
          <template v-if="propertyUpdate.property_client_id">
            <component
              v-if="isPickList(propertyUpdate.property_client_id)"
              :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
              :disabled="propertyUpdate.clear_value"
              :id="`update_value_${propertyUpdate.property_client_id}`"
              class="mb-0"
              :property-client-id="propertyUpdate.property_client_id"
              :object-model="selectedObjectModel"
              v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
              v-model="propertyUpdate.values_to_update_to_array"
            ></component>
            <formula-wrapper
              v-else-if="isDateTime(propertyUpdate.property_client_id)"
              field-name="value_to_update_to"
              :parent="propertyUpdate"
              :dynamic-options="updatePropertyValueDateFormulaDynamicOptions"
              serverside-warning-tooltip
            >
              <template #value>
                <component
                  :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
                  :id="`update_value_${propertyUpdate.property_client_id}`"
                  class="mb-0"
                  :property-client-id="propertyUpdate.property_client_id"
                  :object-model="selectedObjectModel"
                  v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
                  v-model="propertyUpdate.value_to_update_to"
                  :disabled="propertyUpdate.clear_value"
                ></component>
              </template>
            </formula-wrapper>
            <component
              v-else
              :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
              :disabled="propertyUpdate.clear_value"
              :isDisabled="propertyUpdate.clear_value"
              :id="`update_value_${propertyUpdate.property_client_id}`"
              class="mb-0"
              :property-client-id="propertyUpdate.property_client_id"
              :object-model="selectedObjectModel"
              v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
              v-model="propertyUpdate.value_to_update_to"
            ></component>
          </template>
        </configure-property-update>
      </panel-block>
    </template>
    <panel-block>
      <panel-actions>
        <button @click="addPropertyUpdate" type="button" class="btn grey-to-blue full-sz" id="add-notification">
          Add Property to Update
        </button>
      </panel-actions>
    </panel-block>
  </template>
  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.relatedObjectPropertyUpdatable)">
    <panel-item>

      <label :for="selectedObjectModelTrigger.idForProp('linked_relationship_client_id')" class="a-select-label">
        Update Which Relationship?</label>
      <a-select :options="linkedRelationshipSearchOptions"
                compress
                force-nullify-if-null
                bind-by-object
                :id="selectedObjectModelTrigger.idForProp('linked_relationship_client_id')"
                :key="selectedObjectModelTrigger.linked_relationship_client_id ? selectedObjectModelTrigger.linked_relationship_client_id: 'select-relationship'"
                :value="getRelationOption()"
                @input="setRelationOption"
                ></a-select>
    </panel-item>
    <panel-item v-if="!!selectedObjectModelTrigger.linked_relationship_client_id">

      <div v-for="relatedModelUpdate in selectedObjectModelTrigger.relatedModelUpdatesArray">
        <panel-block>
          <configure-related-model-update :related-model-update="relatedModelUpdate"
                                          :linkable-models="linkedObjectModels">

          </configure-related-model-update>
        </panel-block>
      </div>
      <panel-actions>
        <button @click="addRelatedModelUpdate" type="button" class="btn grey-to-blue full-sz"
                id="add-related-model-update">
          Add Another Model to Update
        </button>
      </panel-actions>

    </panel-item>

  </panel-block>

  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.removeRelationshipable)">
    <panel-item>

      <label :for="selectedObjectModelTrigger.idForProp('relationship_id')" class="a-select-label">
        Remove which relationship?</label>
      <a-select :options="relationshipSearchOptions"
                :id="selectedObjectModelTrigger.idForProp('relationship_id')"
                :key="selectedObjectModelTrigger.relationship_id ? selectedObjectModelTrigger.relationship_id: 'select-relationship'"
                compress
                force-nullify-if-null
                bind-by-object
                :value="getRemoveOrEstablishRelationOption()"
                @input="setRemoveOrEstablishRelationOption"
                ></a-select>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.establishRelationshipable)">
    <panel-item>

      <label :for="selectedObjectModelTrigger.idForProp('foreign_key')" class="a-select-label">
        Foreign Key?</label>
      <a-select
        :options="foreignKeyOptions"
        :id="selectedObjectModelTrigger.idForProp('foreign_key')"
        compress
        force-nullify-if-null
        v-model="selectedObjectModelTrigger.foreign_key"
      ></a-select>


      <label :for="selectedObjectModelTrigger.idForProp('relationship_id')" class="a-select-label">
        Establish which relationship?</label>
      <a-select :options="relationshipSearchOptions"
                :id="selectedObjectModelTrigger.idForProp('relationship_id')"
                :key="selectedObjectModelTrigger.relationship_id ? selectedObjectModelTrigger.relationship_id: 'select-relationship'"
                compress
                force-nullify-if-null
                bind-by-object
                :value="getRemoveOrEstablishRelationOption()"
                @input="setRemoveOrEstablishRelationOption"
                ></a-select>

      <template v-for="linkedModel in linkedObjectModels">
        <template>
          <label :for="linkedModel.client_id" class="a-select-label">
            {{ `${linkedModel.title}'s Primary Key` }}</label>
          <a-select :options="objectModelPropertyOptions(linkedModel)"
                    :id="linkedModel.client_id"
                    compress
                    force-nullify-if-null
                    bind-by-object
                    :value="getPrimaryKey(linkedModel)"
                    @input="setPrimaryKey(linkedModel, $event)"
          ></a-select>
        </template>
      </template>
    </panel-item>
  </panel-block>

  <panel-block>
    <panel-item>
      <panel-title>Notification</panel-title>

      <configure-notification
        :parent="selectedObjectModelTrigger"
        :dynamic-fields-handler="dynamicFieldsHandler"
        :notification-factory="ObjectModelTriggerNotificationFactory"
        :permittee-options="notificationPermiteeOptions"></configure-notification>
    </panel-item>
  </panel-block>
</div>
